export default __webpack_public_path__ + "static/driveclear-demo-v1-0d878a38a591825ea92a9f5b9181ca6d.gif";